var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('QuizSingleSelect',{attrs:{"options":_vm.quizQuestions},on:{"optChanged":_vm.onOptionChanged}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quiz-content"},[_c('h2',[_vm._v("What is your gender?")])])
}]

export { render, staticRenderFns }